import { minimumDefaultCartQuantity } from '@spa/lib/const';

export interface GetInitialQuantityToBuyParams {
  readonly isPreOrderActive?: boolean;
  readonly quantity?: number;
  readonly saleMinimumQuantity?: number | null | undefined;
}

export const getInitialQuantityToBuy = ({
  isPreOrderActive = false,
  quantity,
  saleMinimumQuantity
}: GetInitialQuantityToBuyParams = {}): number => {
  if (isPreOrderActive) {
    return 1;
  }

  const minQuantity =
    saleMinimumQuantity && saleMinimumQuantity > 0
      ? saleMinimumQuantity
      : minimumDefaultCartQuantity;

  return quantity !== undefined && quantity > 0 ? Math.max(quantity, minQuantity) : minQuantity;
};
